import './style.css';
import Map from 'ol/Map.js';
import OSM from 'ol/source/OSM.js';
import TileLayer from 'ol/layer/Tile.js';
import View from 'ol/View.js';
import Overlay from 'ol/Overlay.js';
import {fromLonLat} from 'ol/proj.js';

const map = new Map({
  target: 'map',
  layers: [
    new TileLayer({
      source: new OSM()
    })
  ],
  view: new View({
    center: fromLonLat([8.155, 51.033]),
    zoom: 15
  })
});

var numRows = document.getElementById('table1').rows.length;
//document.writeln("Rows: " + rows.toString()+ "<br>");
var numCols = document.getElementById('table1').rows[0].cells.length;
//document.writeln("Cols: " + cols.toString() + "<br>");
//document.write("<br>");

var dtable = new Array(numRows);
var gpos = new Array(numRows-1);

for(var i = 0; i < numRows; i++)
{
	dtable[i] = new Array(numCols);
	for(var j = 0; j < numCols; j++)
	{
		dtable[i][j] = document.getElementById('table1').rows[i].cells[j].firstChild.nodeValue;
	}
	if(i > 0) // the first line is the head line
	{
     var pos = fromLonLat([parseFloat(dtable[i][2]), parseFloat(dtable[i][3])]);
     gpos[i-1] = pos;
     var marker = new Overlay({position: pos, positioning: 'center-center', element: document.getElementById('marker' + i.toString()), stopEvent: true});
     map.addOverlay(marker);
	}
}
